import { HttpClient } from '@angular/common/http';
import { Base } from './base';

export class Faucets extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'faucets');
  }

  create(record: any) {
    return this.api.create(record);
  }
}
